import { getOr, pipe } from 'lodash/fp';

export const getRetentionReport = getOr({}, 'customers.retention');

export const getCustomerRetainedVisitsCount = getOr(2, 'customers.retention.customerRetainedVisitsCount');

export const getRetentionReportQuarters = pipe(
  getRetentionReport,
  getOr([], 'quarters')
);

export const getRetentionTable = (state) => {
  const { report } = getRetentionReport(state);
  if (!report) return [];

  return report.barbers.concat([report.shop]);
};
